import React, { useState, useEffect } from 'react';
import { Divider, FormHelperText, IconButton, InputAdornment, Snackbar, TextField, Typography } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import IcDelete from '../../assets/ic_delete.png';
import IcButton from '../../assets/icon_button.png';
import { format } from 'date-fns';
import api from '../api';
import Loader from 'react-loader-spinner'
import MuiAlert from '@material-ui/lab/Alert';
import InputMask from 'react-input-mask';
import SyncOutlinedIcon from '@material-ui/icons/SyncOutlined';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AddPasien(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [newPasien, setNewPasien] = useState({
        jenisKelamin: ""
    })
    const [namaPasien, setNamaPasien] = useState("")
    const [noKTP, setNOKTP] = useState("")
    const [phone, setPhone] = useState("")
    const [mobilePhone, setMobilePhone] = useState("")
    const [gender, setGender] = useState(null)
    const [alamat, setAlamat] = useState("")
    const [rekamMedis, setRekamMedis] = useState("")
    const [tglLahir, setTglLahir] = useState(new Date());
    const listJenkel = [
        { value: 'Laki-laki', id: 'L' },
        { value: 'Perempuan', id: 'P' },
    ]
    const listVerifikasi = [
        { value: 'Belum Terverifikasi', id: 0 },
        { value: 'Terverifikasi', id: 1 },
    ]
    const [verifikasi, setVerifikasi] = useState(listVerifikasi[0]);
    const [asuransiLength, setAsuransiLength] = useState([]);
    const [categoryProvider, setCategoryProvider] = useState([]);
    const [category, setCategory] = useState(null);
    const [listProvider, setListProvider] = useState([]);
    const [provider, setProvider] = useState(null);
    const [loading, setLoading] = React.useState(false);
    const [namaBPJS, setNamaBPJS] = useState("")
    const [noBPJS, setNoBPJS] = useState("")
    const [indexValue, setIndexValue] = useState(null)
    const [autoGenerateNoRM, setAutoGenerateNoRM] = useState(null)
    const [clickGenerate, setClickGenerate] = useState(false)

    const [textNama, setTextNama] = React.useState("");
    const [errorNama, setErrorNama] = React.useState(false);
    const [textPhone, setTextPhone] = React.useState("");
    const [errorPhone, setErrorPhone] = React.useState(false);
    const [textMobilePhone, setTextMobilePhone] = React.useState("");
    const [errorMobilePhone, setErrorMobilePhone] = React.useState(false);
    const [textNoKTP, setTextNoKTP] = React.useState("");
    const [errorNoKTP, setErrorNoKTP] = React.useState(false);
    const [textAlamat, setTextAlamat] = React.useState("");
    const [errorAlamat, setErrorAlamat] = React.useState(false);
    const [textNamaBPJS, setTextNamaBPJS] = React.useState("");
    const [errorNamaBPJS, setErrorNamaBPJS] = React.useState(false);
    const [textNoBPJS, setTextNoBPJS] = React.useState("");
    const [errorNoBPJS, setErrorNoBPJS] = React.useState(false);
    const [errorGender, setErrorGender] = React.useState(false);
    const [visibleProvider, setVisibleProvider] = React.useState(false);
    const [nonIntergrasi, setNonIntergrasi] = useState(false)

    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);

    const [formated, setFormated] = useState("")

    useEffect(() => {
        setLoading(true)
        getCategoryProvider()
        getParam()
        getParameter()
    }, [])

    const getParameter = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    response.data.data.map((item) => {
                        if (item.param_code === "INTEGRATION_RESERVATION") {
                            if (item.param_value === "false") {
                                setNonIntergrasi(false)
                            } else {
                                setNonIntergrasi(true)
                            }

                        }
                    })
                }
            }
        })
    }

    const getParam = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let idx = response.data.data.findIndex((val) => val.param_code === "MEDICAL_RECORD_NO_FORMAT")
                    console.log(idx);
                    if (idx > -1) {
                        setFormated(response.data.data[idx].param_value)
                    }
                }
            }
        })
    }

    const getAutoGenerate = () => {
        api.create().getNoRM().then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    setAutoGenerateNoRM(response.data.data)
                    setLoading(false)
                    forceUpdate()
                }
            }
        })
    }

    const getCategoryProvider = () => {
        api.create().getCategoryProvider().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setCategoryProvider(response.data.data)
                    setLoading(false)
                    forceUpdate()
                }
            }
        })
    }

    const getProviderByCategory = (type, index) => {
        setLoading(true)
        api.create().getProviderByCategory(type).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setListProvider(response.data.data)
                    // listProvider.splice(index, 0, response.data.data)
                    // let idProv = response.data.data.findIndex((val) => val.code === code)
                    // if (idProv > -1) {
                    //     setProvider(response.data.data[idProv])
                    //     forceUpdate()
                    // }
                    setLoading(false)
                    forceUpdate()
                }
            }
        })
    }

    const handleSaveProvider = () => {
        asuransiLength[indexValue].code = provider.code
        asuransiLength[indexValue].nama = provider.name
        asuransiLength[indexValue].tipe = category.type
        asuransiLength[indexValue].categoryName = category.type
        setCategory(null)
        setProvider(null)
        setVisibleProvider(false)
        forceUpdate()
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const doSubmit = (e) => {
        let regName = /^[a-zA-Z\s]+$/
        let regAlpha = /^[a-zA-Z]+$/
        let regNumber = /^[0-9]+$/
        if (namaPasien === "") {
            setTextNama("Nama Pasien Harus Diisi")
            setErrorNama(true)
            // } else if (!regName.test(namaPasien)) {
            //     setTextNama("Nama Pasien Tidak Boleh Berisi Angka & Karakter")
            //     setErrorNama(true)
        } else if (noKTP === "") {
            setTextNoKTP("No KTP Harus Diisi")
            setErrorNoKTP(true)
            // } else if (!regNumber.test(noKTP)) {
            //     setTextNoKTP("No KTP Harus Berisi Angka")
            //     setErrorNoKTP(true)
        } else if (phone === "") {
            setTextPhone("No. Handphone Harus Diisi")
            setErrorPhone(true)
        } else if (!regNumber.test(phone)) {
            setTextPhone("No. Handphone Harus Berisi Angka")
            setErrorPhone(true)
        } else if (mobilePhone === "") {
            setTextMobilePhone("No. Telepon Harus Diisi")
            setErrorMobilePhone(true)
        } else if (!regNumber.test(mobilePhone)) {
            setTextMobilePhone("No. Telepon Harus Berisi Angka")
            setErrorMobilePhone(true)
        } else if (gender === null || gender === "") {
            setErrorGender(true)
        } else if (alamat === "") {
            setTextAlamat("Alamat Harus Diisi")
            setErrorAlamat(true)
        } else if (namaBPJS === "" && noBPJS !== "") {
            setTextNamaBPJS("Nama BPJS Wajib diisi")
            setErrorNamaBPJS(true)
        } else if (noBPJS === "" && namaBPJS !== "") {
            setTextNoBPJS("No Kartu BPJS Wajib diisi")
            setErrorNoBPJS(true)
        } else {
            let asuransi = []
            if (asuransiLength.length > 0) {
                asuransiLength.map(item => {
                    if (item.nomor === "" || item.nama === "" || item.namaPasien === "" || item.code === "") {
                        setOpenAlert(true)
                        setMessageAlert('Data asuransi belum lengkap!')
                        setStatusAlert("warning")
                    } else {
                        asuransi.push({
                            "insurance_no": item.nomor,
                            "insurance_name": item.nama,
                            "patient_name": item.namaPasien,
                            "provider_code": item.code,
                            "provider_category": item.categoryName
                        })
                        let payload = {
                            "name": namaPasien,
                            "phone": phone,
                            "mobile_phone": mobilePhone,
                            "gender": gender,
                            "date_of_birth": format(tglLahir, 'yyyy-MM-dd'),
                            "identity_no": noKTP,
                            "address": alamat,
                            "bpjs_no": noBPJS,
                            "bpjs_name": namaBPJS,
                            "insurance": asuransi,
                            "is_verified": verifikasi.id,
                            "medical_record_no": rekamMedis,
                            "is_edit_insurance": false,
                            "is_admin": true,
                        }
                        console.log(JSON.stringify(payload));
                        props.createPasien(payload)
                        props.onClose()
                    }
                })
            } else {
                let payload = {
                    "name": namaPasien,
                    "phone": phone,
                    "mobile_phone": mobilePhone,
                    "gender": gender,
                    "date_of_birth": format(tglLahir, 'yyyy-MM-dd'),
                    "identity_no": noKTP,
                    "address": alamat,
                    "bpjs_no": noBPJS,
                    "bpjs_name": namaBPJS,
                    "insurance": [],
                    "is_verified": verifikasi.id,
                    "medical_record_no": rekamMedis,
                    "is_edit_insurance": false,
                    "is_admin": true,
                }
                console.log(JSON.stringify(payload));
                props.createPasien(payload)
                props.onClose()
            }
        }
    }

    const handleTambah = () => {
        asuransiLength.push({
            nomor: "",
            nama: "",
            namaPasien: "",
            code: "",
            tipe: "",
            categoryName: ""
        })
        console.log(asuransiLength);
        forceUpdate()
    }

    const handleHapus = (index) => {
        asuransiLength.splice(index, 1)
        forceUpdate()
    }

    const handleNamaAsuransi = (val, index) => {
        asuransiLength[index].nama = val
        forceUpdate()
    }

    const handleNomorAsuransi = (val, index) => {
        asuransiLength[index].nomor = val
        forceUpdate()
    }
    const handleNamaPasienAsuransi = (val, index) => {
        asuransiLength[index].namaPasien = val
        forceUpdate()
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 2000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {loading && (loadingComponent)}
            <div className="popup-content background-white" style={{ borderRadius: 30, width: 900 }}>
                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tambah Pasien Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div style={{ maxHeight: 700, overflow: 'scroll', backgroundColor: '#fff' }}>
                    <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                        <div className="column-1">
                            <div className="">
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="namaPasien"
                                    name="namaPasien"
                                    label="Nama Pasien"
                                    required={true}
                                    placeholder={"input nama pasien"}
                                    value={namaPasien}
                                    error={errorNama}
                                    helperText={textNama}
                                    onChange={(e) => {
                                        setNamaPasien(e.target.value)
                                        setErrorNama(false)
                                        setTextNama("")
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {

                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div className="">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="tanggal Lahir"
                                        label="Tanggal Lahir"
                                        required={true}
                                        format="dd/MM/yyyy"
                                        maxDate={new Date()}
                                        value={tglLahir}
                                        onChange={(date) => {
                                            setTglLahir(date)
                                            forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <div className="">
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="noHp"
                                    name="noHp"
                                    label="No. Handphone Pasien"
                                    placeholder={"Input No. hp"}
                                    required={true}
                                    error={errorMobilePhone}
                                    helperText={textMobilePhone}
                                    value={mobilePhone}
                                    onChange={(e) => {
                                        setMobilePhone(String(e.target.value).replace(/^(?!00[^0])0/, ''))
                                        setErrorMobilePhone(false)
                                        setTextMobilePhone("")
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        maxLength: 12,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start" style={{ margin: 0, marginRight: 5 }}>+62</InputAdornment>,
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>

                            <div className="" style={{ marginTop: 15 }}>
                                <TextField
                                    style={{ width: '100%' }}
                                    required={true}
                                    id="alamat"
                                    name="alamat"
                                    label="Alamat"
                                    placeholder={"Alamat"}
                                    error={errorAlamat}
                                    helperText={textAlamat}
                                    value={alamat}
                                    onChange={(e) => {
                                        setAlamat(e.target.value)
                                        setErrorAlamat(false)
                                        setTextAlamat("")
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {

                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>

                            <Autocomplete
                                options={listVerifikasi}
                                getOptionLabel={(option) => option.value}
                                style={{ marginTop: 15 }}
                                disableClearable
                                id="tipe"
                                onChange={(event, newInputValue) => {
                                    setVerifikasi(newInputValue)
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputLabelProps={{
                                            style: {
                                                color: '#7e8085',
                                            }
                                        }}
                                        label="Verifikasi"
                                    />
                                }
                                value={verifikasi}
                            />
                        </div>

                        <div className="column-2">
                            <div className="">
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="noKtp"
                                    required={true}
                                    name="noKtp"
                                    label="No. KTP"
                                    type=""
                                    placeholder={"Input No KTP"}
                                    error={errorNoKTP}
                                    helperText={textNoKTP}
                                    // value={noKTP}
                                    onChange={(e) => {
                                        setNOKTP(e.target.value)
                                        setErrorNoKTP(false)
                                        setTextNoKTP("")
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        maxLength: 16,
                                        style: {

                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div className="" style={{ marginTop: 15 }}>
                                {/* <Autocomplete
                                    options={listJenkel}
                                    getOptionLabel={(option) => option.value}
                                    debug
                                    id="tipe"
                                    onChange={(event, newInputValue) => {
                                        setGender(newInputValue === null ? "" : newInputValue.id)
                                    }}
                                    // onChange={(event, newInputValue) => setNewPasien({
                                    //     ...newPasien,
                                    //     jenisKelamin: newInputValue !== null ? newInputValue.value : null
                                    // })}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{
                                                style: {
                                                    color: '#7e8085',
                                                }
                                            }}
                                            label="Jenis Kelamin"
                                        />
                                    }
                                /> */}
                                <FormControl className={classes.formControl} style={{ width: '100%', marginTop: 2 }} error={errorGender} required>
                                    <InputLabel id="demo-simple-select-error-label">Jenis Kelamin</InputLabel>
                                    <Select
                                        required={true}
                                        native
                                        onChange={(e) => {
                                            setGender(e.target.value)
                                            setErrorGender(false)
                                        }}
                                        inputProps={{
                                            name: 'gender',
                                        }}
                                    >
                                        <option value=""></option>
                                        {listJenkel.map(element => (
                                            <option value={element.id}>{element.value}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                                {errorGender && (
                                    <FormHelperText style={{ color: 'red' }}>Jenis Kelamin Harus Diisi</FormHelperText>
                                )}
                            </div>

                            <div className="" style={{ marginTop: 8 }}>
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="notelepon"
                                    name="notelepon"
                                    label="No. Telepon Pasien"
                                    placeholder={"Input No. Telepon"}
                                    required={true}
                                    error={errorPhone}
                                    helperText={textPhone}
                                    value={phone}
                                    onChange={(e) => {
                                        setPhone(String(e.target.value).replace(/^(?!00[^0])0/, ''))
                                        setErrorPhone(false)
                                        setTextPhone("")
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        maxLength: 12,
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>

                            <div className="">
                                <InputMask
                                    mask={String(formated).split('#').join('*')}
                                    value={rekamMedis}
                                    onChange={(e) => {
                                        setRekamMedis(e.target.value)
                                        setClickGenerate(false)
                                        forceUpdate()
                                    }}
                                >
                                    {() =>
                                        <TextField
                                            style={{ width: '100%', marginTop: 11 }}
                                            id="rekam"
                                            name="rekam"
                                            label="No. Rekam Medis Pasien"
                                            placeholder={"input No. Rekam"}
                                            required={true}
                                            value={rekamMedis}
                                            // onChange={(e) => {
                                            //     setRekamMedis(e.target.value)
                                            //     forceUpdate()
                                            // }}
                                            inputProps={{
                                                style: {

                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {

                                                    color: '#7e8085',
                                                }
                                            }}
                                            // InputProps={{
                                            //     endAdornment:
                                            //         <InputAdornment position="end">
                                            //             <IconButton
                                            //                 aria-label="open drawer"
                                            //                 onClick={() => {
                                            //                     getAutoGenerate()
                                            //                     setClickGenerate(true)
                                            //                 }}
                                            //                 edge="start"
                                            //                 title="Auto Generate" 
                                            //                 disabled={rekamMedis === "" ? false : true}
                                            //                 style={{ outline: 'none' }}
                                            //             >
                                            //                 <SyncOutlinedIcon />
                                            //             </IconButton>
                                            //         </InputAdornment>,
                                            // }}
                                        />
                                    }
                                </InputMask>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 20, display: 'grid', paddingLeft: 50, paddingRight: 50 }}>
                        <Typography style={{ justifySelf: 'flex-start', marginBottom: 10, fontWeight: 'bold' }}>BPJS</Typography>
                        <Divider />
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 0 }}>
                            <div className="column-1">
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 7 }}
                                        id="namaBPJS"
                                        required={noBPJS !== "" ? true : false}
                                        name="namaBPJS"
                                        label="Nama Peserta BPJS"
                                        error={errorNamaBPJS}
                                        helperText={textNamaBPJS}
                                        placeholder={"input Nama"}
                                        onChange={(e) => {
                                            setNamaBPJS(e.target.value)
                                            setErrorNamaBPJS(false)
                                            setTextNamaBPJS("")
                                            forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-2">
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 7 }}
                                        required={namaBPJS !== "" ? true : false}
                                        id="nomorKartuBPJS"
                                        name="nomorKartuBPJS"
                                        label="Nomor Kartu BPJS"
                                        error={errorNoBPJS}
                                        helperText={textNoBPJS}
                                        placeholder={"Input Nomor Kartu BPJS"}
                                        onChange={(e) => {
                                            setNoBPJS(e.target.value)
                                            setErrorNoBPJS(false)
                                            setTextNoBPJS("")
                                            forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 40, paddingLeft: 50, paddingRight: 50, marginBottom: 40 }}>
                        <div style={{ display: 'Flex', justifyContent: 'space-between' }}>
                            <Typography style={{ marginBottom: 10, fontWeight: 'bold' }}>Asuransi</Typography>
                            <button style={{ outline: 'none', backgroundColor: 'transparent', borderColor: 'transparent', cursor: 'pointer' }}
                                onClick={() => handleTambah()}
                            >
                                <Typography style={{ marginBottom: 10, fontWeight: 'bold', color: '#0066ff' }}>+ Tambah Asuransi Baru</Typography>
                            </button>
                        </div>
                        <Divider />
                        {asuransiLength && asuransiLength.map((item, index) => (
                            <div className="grid grid-3x grid-mobile-none gap-15px" style={{ paddingRight: 60, paddingLeft: 0 }}>
                                <div className="column-1">
                                    <div className="">
                                        <TextField
                                            style={{ width: '100%', marginTop: 7 }}
                                            label="Nama Asuransi"
                                            placeholder={"input nama asuransi"}
                                            onClick={() => {
                                                setIndexValue(index)
                                                setVisibleProvider(true)
                                            }}
                                            // onChange={(e) => handleNamaAsuransi(e.target.value, index)}
                                            inputProps={{
                                                style: {
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    color: '#7e8085',
                                                }
                                            }}
                                            value={item.nama}
                                        />
                                    </div>
                                </div>
                                <div className="column-2" >
                                    <div className="" style={{ display: 'flex' }}>
                                        <TextField
                                            style={{ width: '100%', marginTop: 7 }}
                                            id="nomorKartu"
                                            name="nomorKartu"
                                            label="Nomor Kartu"
                                            placeholder={"input nomor kartu"}
                                            onChange={(e) => handleNomorAsuransi(e.target.value, index)}
                                            inputProps={{
                                                style: {
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    color: '#7e8085',
                                                }
                                            }}
                                            value={item.nomor}
                                        />
                                    </div>
                                </div>
                                <div className="column-3" style={{ width: '130%' }} >
                                    <div className="" style={{ display: 'flex', textAlign: 'left', whiteSpace: 'nowrap', justifyContent: 'space-between' }}>
                                        <TextField
                                            style={{ width: '90%', marginTop: 7 }}
                                            id="nomorKartu"
                                            name="nomorKartu"
                                            label="Nama Tertera Dikartu Jaminan"
                                            placeholder={"input Nama Tertera Dikartu Jaminan"}
                                            onChange={(e) => handleNamaPasienAsuransi(e.target.value, index)}
                                            inputProps={{
                                                style: {
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    color: '#7e8085',
                                                }
                                            }}
                                            value={item.namaPasien}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            style={{ borderColor: 'transparent', outline: 'none', marginTop: 10, marginLeft: 10 }}
                                            onClick={() => handleHapus(index)}
                                        >
                                            <div style={{ width: 24, height: 24, backgroundColor: '#278863', borderRadius: 15 }}>
                                                <img src={IcDelete} style={{ width: 12, height: 12 }} />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => doSubmit(e)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>

            {visibleProvider && (
                <div className="App app-popup-show">
                    <div className="popup-content-low background-white" style={{ borderRadius: 20, margin: 'auto', overflow: 'auto' }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 20, borderTopLeftRadius: 20, backgroundColor: '#f5f5f5' }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, }}>Pilih Provider</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleProvider(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none" style={{ padding: 20 }}>
                            <div className="column-1" style={{ textAlign: 'left' }}>
                                <Autocomplete
                                    options={categoryProvider}
                                    getOptionLabel={(option) => option.type}
                                    style={{ marginTop: 7, width: '95%' }}
                                    id="tipe"
                                    onChange={(event, newInputValue) => {
                                        getProviderByCategory(newInputValue.type)
                                        setCategory(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{
                                                style: {
                                                    color: '#7e8085',
                                                }
                                            }}
                                            label="Kategori"
                                        />
                                    }
                                />
                            </div>

                            <div className="column-2" style={{ textAlign: 'left' }}>
                                <Autocomplete
                                    options={listProvider}
                                    getOptionLabel={(option) => option.name}
                                    style={{ marginTop: 7, width: '95%' }}
                                    id="tipe"
                                    onChange={(event, newInputValue) => {
                                        setProvider(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{
                                                style: {
                                                    color: '#7e8085',
                                                }
                                            }}
                                            label="Provider"
                                        />
                                    }
                                />
                            </div>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div onClick={() => setVisibleProvider(false)} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div onClick={(e) => handleSaveProvider()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}